// @flow

import * as React from 'react';
import Localize from '@ta/platform.i18n';
import classNames from '@ta/common.classnames';
import styles from './BubbleRatingWithReviewCount.css';

import BubbleRatingWithLabel from './BubbleRatingWithLabel';

type Props = {|
  /** the rating number multiplied by ten (i.e. for a 3.5 rating use 35). */
  rating: number,

  /** the number of reviews */
  numReviews: number,

  /** the font-size of the text in px */
  fontSize: ?number,

  /** the url you'd like the reviews to link to */
  url: string,

  /** Dotted underline for review count */
  dottedRatingUnderline: boolean,

  /** underline and change cursor to a pointer on mouse over just the review count */
  reviewCountHoverable: ?boolean,

  /** Optional action on link click */
  onClick?: (e: SyntheticEvent<>) => void,

  /** use stars instead of bubbles for affiliate reviews */
  useAffiliateStars: boolean,

  /** bubble rating vertical align styles */
  bubbleRatingVerticalAlign: ?string,
|};

/**
 * A bubble rating with review count link
 */
const BubbleRatingWithLinkedReviewCount = (props: Props) => (
  <span className={styles.poiReviewRatingWrapper}>
    <BubbleRatingWithLabel
      rating={props.rating}
      useAffiliateStars={props.useAffiliateStars}
      bubbleRatingVerticalAlign={props.bubbleRatingVerticalAlign}
      label={
        <a href={props.url} onClick={props.onClick}>
          <span
            className={classNames(styles.reviewCount, {
              [styles.dottedUnderline]: props.dottedRatingUnderline,
              [styles.reviewCountHoverable]: props.reviewCountHoverable,
            })}
            style={
              // TODO: Filed as WP-868
              /* istanbul ignore next */
              props.fontSize && { fontSize: props.fontSize }
            }
          >
            <Localize id="mobile_reviews_plural" args={{ '0': props.numReviews }} />
          </span>
        </a>
      }
    />
  </span>
);

BubbleRatingWithLinkedReviewCount.defaultProps = {
  fontSize: null,
  onClick: undefined,
  dottedRatingUnderline: false,
  reviewCountHoverable: false,
  useAffiliateStars: false,
  bubbleRatingVerticalAlign: null,
};

export default BubbleRatingWithLinkedReviewCount;
